import React from 'react';

class ItemSelected extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      label: this.props.label,
      value: this.props.value,
      capQuanHuyen: this.props.capQuanHuyen
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      label: nextProps.label,
      value: nextProps.value,
      capQuanHuyen: nextProps.capQuanHuyen
    })
  }

  onClick() {
    this.props.removeSelected();
  }

  render() {
    return (
      <span className="rs-item-selected">
        <span className='rs-item-close' onClick={this.onClick.bind(this)}>×</span>
        <span className='rs-item-name'>{this.state.label + this.props.capQuanHuyen}</span>
      </span>
    );
  }
}

ItemSelected.defaultProps = {
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  label: '',
  value: ''
}

export default ItemSelected;



// WEBPACK FOOTER //
// ./src/components/tt-forms/react-tree-select/ItemSelected.jsx